// extracted by mini-css-extract-plugin
export default {"heading":"ChangedMindAboutTakingOVOSection_heading__mYlCB","cta":"ChangedMindAboutTakingOVOSection_cta__PWn1B"};